import React from "react";

function Footer() {
  return (
<footer>
        <div className="footerfull">
          <div className="box_footer">
            <h5>Our Boutiques</h5>
            <ul>
              <li>Christian Dior Couture Boutiques</li>
              <li>Christian Dior Couture Boutiques</li>
            </ul>
          </div>

          <div className="box_footer">
            <h5>Client Services</h5>
            <ul>
              <li>Contact</li>
              <li>FAQ</li>
            </ul>
          </div>

          <div className="box_footer">
            <h5>The house of dior</h5>
            <ul>
              <li>Legal Terms</li>
              <li>Follow Us</li>
              <li>Careers</li>
              <li>Site Map</li>
            </ul>
          </div>

          <div className="box_footer">
            <h5>Explore More</h5>
            <ul>
              <li>Gift Sets</li>
              <li>Make-up Bestsellers</li>
              <li>Fragrance Bestsellers</li>
              <li>Skincare Bestsellers</li>
            </ul>
          </div>
        </div>
      </footer>
  );
}

export default Footer;
